import { FunctionComponent, useState } from 'react'
import useStyles from './styles'
import Modal from '@/components/Modal'
import { CopyToClipboard } from '@/components/CopyToClipboard'
import { Button, Input, toast } from '@conexasaude/hero'

import { inviteToVideoCall } from '../../video-call-services'
import { InviteToCallModalProps } from './types'
import Icon from '@/components/HeroIcons'
import { RenderIf } from '@/components/RenderIf'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'

const InviteToCallModal: FunctionComponent<InviteToCallModalProps> = ({
  sessionId,
}) => {
  const { modalContainer, footer } = useStyles()
  const [guestName, setGuestName] = useState('')
  const [inviteLink, setInviteLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { closeModal } = useModalContext()

  const generateInviteLink = () => {
    setIsLoading(true)
    inviteToVideoCall(sessionId, guestName)
      .then(data => {
        setInviteLink(data.object)
      })
      .catch(err => {
        const errorMessage =
          err?.response?.data?.msg || err?.response?.msg || err.message

        toast(errorMessage, {
          variant: 'danger',
          autoClose: 5000,
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const clearModalData = () => {
    setGuestName('')
    setInviteLink('')
  }

  const closeAndClearModal = () => {
    clearModalData()
    closeModal()
  }

  return (
    <Modal id="INVITE_TO_CALL_MODAL" onDismiss={clearModalData}>
      <div css={modalContainer}>
        <p>Digite o nome do convidado para gerar o link da chamada.</p>

        <div className="input-section">
          <Input
            value={guestName}
            onChange={event => setGuestName(event.target.value)}
            label={`Nome do convidado`}
            placeholder="Digite o nome do convidado"
            required
          />
        </div>
        <RenderIf condition={!!inviteLink}>
          <div className="link-area">
            <CopyToClipboard
              onActionClick={() => closeAndClearModal()}
              value={inviteLink}
            />
          </div>
        </RenderIf>

        <div css={footer}>
          <Button
            onClick={() => generateInviteLink()}
            disabled={!guestName || isLoading || !!inviteLink}
            size="sm"
            endIcon={isLoading ? <Icon name="loading" /> : null}
          >
            Gerar link
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default InviteToCallModal
